import { NpaCritical, NpaIconOld, NpaInfo, NpaWarning, SizeObject } from '@circe/core';

type ModalTypeCustom = 'custom';
export type ModalTypes = NpaInfo | NpaWarning | NpaCritical | ModalTypeCustom;
export type ModalSizes = 'regular' | 'small' | 'medium' | 'large' | 'extraLarge' | 'custom';

export interface ModalTypesDefinition {
  info: NpaInfo;
  critical: NpaCritical;
  warning: NpaWarning;
  custom: ModalTypeCustom;
}
export const modalTypes: ModalTypesDefinition = {
  info: 'info',
  critical: 'critical',
  warning: 'warning',
  custom: 'custom'
};

export enum ModalSizesKeys {
  regular = 'regular',
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extraLarge',
  custom = 'custom'
}

export interface ModalSizesDefinition {
  [ModalSizesKeys.regular]: 'regular';
  [ModalSizesKeys.small]: 'small';
  [ModalSizesKeys.medium]: 'medium';
  [ModalSizesKeys.large]: 'large';
  [ModalSizesKeys.extraLarge]: 'extraLarge';
  [ModalSizesKeys.custom]: 'custom';
}

export const modalSizes: ModalSizesDefinition = {
  [ModalSizesKeys.regular]: 'regular',
  [ModalSizesKeys.small]: 'small',
  [ModalSizesKeys.medium]: 'medium',
  [ModalSizesKeys.large]: 'large',
  [ModalSizesKeys.extraLarge]: 'extraLarge',
  [ModalSizesKeys.custom]: 'custom'
};

export const modalSizesValues: Record<ModalSizesKeys, SizeObject> = {
  regular: { width: { value: 560, unit: 'px' }, height: { value: 280, unit: 'px' } },
  small: { width: { value: 326, unit: 'px' }, height: { value: 280, unit: 'px' } },
  medium: { width: { value: 794, unit: 'px' }, height: { value: 280, unit: 'px' } },
  large: { width: { value: 1026, unit: 'px' }, height: { value: 280, unit: 'px' } },
  extraLarge: { width: { value: 1260, unit: 'px' }, height: { value: 280, unit: 'px' } },
  custom: null
};
export const MINIMUM_MODAL_HEIGHT = 230;
export const MINIMUM_MODAL_WIDTH = 300;

export interface ModalConfig {
  enableAnimation?: boolean;
  clickOutside?: boolean;
  showDefaultHeader?: boolean;
  closeControl?: boolean;
  fullWindow?: boolean;
  size?: ModalSizesKeys;
  width?: number;
  height?: number;
  type?: ModalTypes;
  iconClassBase?: string;
  overlay?: boolean;
  onlyActionButton?: boolean;
  fullWindowHeaderIcon?: boolean | NpaIconOld;
}

export interface ModalButtonsLabels {
  action?: string;
  cancel?: string;
}
